export default __webpack_public_path__ + "static/b-puszczyk-b71a7a14f543f83becadd236bb2d16d7.jpg";